import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModuleMobi } from '../material/material.module';
import { WidgetPropertyFormsComponent } from '../widgetPropertyForms/widget-property-forms.component';
import { SharedModule,AppPermissionsPipe } from 'shared-library';
import { Customfilter } from '../../pipes/customFilter.pipe';
import { WidgetActionsComponent } from './components/widget-actions/widget-actions.component';
import { WidgetValidationsComponent } from './components/widget-validations/widget-validations.component';
import { WidgetDataFiltersComponent } from './components/widget-data-filters/widget-data-filters.component';
import { MediaModule } from '../media/media.module';



@NgModule({
  declarations: [
    WidgetPropertyFormsComponent,
    WidgetActionsComponent,
    WidgetValidationsComponent,
    WidgetDataFiltersComponent
  ],
  imports: [
    CommonModule,
    MaterialModuleMobi,
    FormsModule,  
    ReactiveFormsModule,
    SharedModule,
    Customfilter,
    MediaModule,
    AppPermissionsPipe
  ],
  exports:[
    WidgetPropertyFormsComponent
  ]
})
export class WidgetPropertyFormsModule { }
